import { isMaintenanceError, isNoAccess, isSessionUnavailable, restore } from '@ventawiz/web-kit'

/**
 * What the authenticated layout should do on arrival.
 *
 * - `in` — there is a session for this app (or maintenance, or an auth service
 *   that cannot be reached right now: the session is intact, so stay and let
 *   the root's maintenance page, or the page's own queries, say so).
 * - `no_access` — signed in, but no organisation of the person's opens
 *   VentaWiz. Not a sign-out: they may have come from User Management, whose
 *   session is fine. The layout says so instead of showing the app.
 * - `out` — no session: go and sign in.
 *
 * Out of the route file (CLAUDE.md §3.2) so it is covered.
 */
export type SessionGate = 'in' | 'no_access' | 'out'

export async function sessionGate(): Promise<SessionGate> {
  try {
    return (await restore()) ? 'in' : 'out'
  } catch (error) {
    if (isMaintenanceError(error) || isSessionUnavailable(error)) return 'in'
    if (isNoAccess(error)) return 'no_access'
    throw error
  }
}
